var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd === undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses === undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.popup = {
	init: function() {
		setTimeout(function() {
			if (!sessionStorage.getItem('popupShown')) {
				$('#front-pop').find('.frontpopup').click();
				sessionStorage.setItem('popupShown', 1);

				setTimeout(function() {
					$('.fancybox-close').click();
				}, 8000);
			}
		}, 500);
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.popup.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	if (document.body.classList.contains('viewCar')) {
		const deviceView = document.getElementById('viewDeviceMain');
		if (deviceView) {
			const deviceLabel = document.getElementById('deviceMainLabel');
			const promo = document.getElementById('promo');
			let len = promo ? 30 : 40;
			if (deviceLabel && deviceLabel.innerText) {
				if (deviceLabel.innerText.length > len) {
					deviceLabel.classList.add('deviceLabelLength');
				}
			}

			// Fix for mobile
			const listElement = $('.salesStatus')[0];

			const addMobileElement = () => {
				menuItem = $('.salesStatus')[0];

				const firstCol = menuItem.parentNode;
				const secondCol = firstCol.nextSibling.nextSibling;

				firstCol.removeChild(menuItem);
				secondCol.appendChild(menuItem);
			};

			const removeMobileElement = () => {
				const menuItem = $('.salesStatus')[0];

				const secondCol = menuItem.parentNode;
				const firstCol = secondCol.previousSibling.previousSibling;

				secondCol.removeChild(menuItem);
				firstCol.appendChild(menuItem);
			}

			let mobile = false;

			if (window.innerWidth < 769) {
				mobile = true;
				addMobileElement();
			}

			window.addEventListener('resize', (e) => {
				if(window.innerWidth < 769) {
					if (!mobile) {
						mobile = true;
						addMobileElement();
					}
				} else {
					if (mobile) {
						mobile = false;
						removeMobileElement();
					}
				}
			});
		}
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	$("a[href='#opnunartimi']").on('click touchStart', function() {
		$("html, body").animate({ scrollTop: $(document).height() }, "slow");

		setTimeout(function() {
			$('.box.opening').addClass('flash');
		},500);
		setTimeout(function() {
			$('.box.opening').removeClass('flash');
		},5000);
		return false;
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});


moya.usedcars = moya.usedcars || {};
moya.usedcars = $.extend(moya.usedcars, {
	initSubmitButton: function(id) {
		$('#'+id).removeAttr('name');
		$('#elm_searchForm_submit').prepend('<a id="dg_reset" class="clear" href="#" onclick="moya.usedcars.clearForm();return false;">Hreinsa leit</a><br />');
		var $form = $('.usedcars__search').find('#searchForm');
		$form.submit(function() {
			$form.find(':input').each(function(){
				this.disabled = !($(this).val());
			});
			return true;
		});
	},

	search: function() {
		var $bOwner = $('#bOwnerFilter');
		if ($bOwner.length === 1) {
			var $check = $bOwner.find('input[type=checkbox]');
			var $hidden = $('input#owner');
			if ($check.length === 1 && $hidden.length === 1) {
				$check.change(function() {
					$hidden.val(this.checked ? 1 : 0);
					$hidden.parents('form').submit();
				});
				$check.prop('checked', parseInt($hidden.val()) > 0);
			}
		}
	},

	compare:function() {
		if (!$('#compareWrapper', '#usedcars')) return false;

		$('.device', '.compare').wrapAll('<div class="devices" />');

		if ($('.device', '#compareWrapper').length > 2) {
			site.owl.init('.devices', {
				nav: true,
				dots: false,
				margin: 0,
				navText:["<i class=\"fa fa-angle-left\" />","<i class=\"fa fa-angle-right\" />"],
				responsive: {
					0: {
						items: 2
					},
					480: {
						items: 2
					},
					768: {
						items: 3
					},
					992: {
						items:4
					},
					1200: {
						items:5
					}
				}
			});
		}
	},

	searchFormDefaultLabels:function() {
		$('.elm_select', '#searchForm').each(function() {
			$(this).find('option:first-child').attr('label', '--').text('--');
		});
	}
});
